import * as React from "react";
import {Button, FormGroup, Grid, Switch, TextField, FormControlLabel} from "@material-ui/core";
import {API} from "aws-amplify";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import {Alert} from "@material-ui/lab";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";
import {
    getProgramEnrollmentByCidDefault,
    IGetProgramEnrollmentByCidRequest
} from "./request/GetProgramEnrollmentByCidRequest";
import { AMAZON_ID } from "../../../../consts/Patterns";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: string
    isJsonInput: boolean
    isLoading: boolean
    jsonInput: string
    request: IGetProgramEnrollmentByCidRequest
    response: any
}

enum InputField {
    PROFILE_ID,
    PROGRAM_NAME
}

class GetProgramEnrollmentByCidSection extends React.Component<IProps, IState> {
    private isValidation: boolean;
    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            isJsonInput: false,
            isLoading: false,
            jsonInput: getProgramEnrollmentByCidDefault,
            request: {} as IGetProgramEnrollmentByCidRequest,
            response: ''
        };

        this.toggleJsonInput = this.toggleJsonInput.bind(this);
        this.setRequest = this.setRequest.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
    }

    public render() {
        return(
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <FormGroup>
                        <FormControlLabel control={ <Switch onChange={ this.toggleJsonInput }/> } label="Toggle Json Input" />
                    </FormGroup>
                </Grid>


                { !this.state.isJsonInput &&
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Profile Id (Required)"
                                variant="outlined"
                                value={ this.state.request.profileId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PROFILE_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="ProgramName (Required)"
                                variant="outlined"
                                value={ this.state.request.programName || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PROGRAM_NAME, event) }
                            />
                        </Grid>
                    </Grid>
                }

                { this.state.isJsonInput &&
                    <Grid item xs>
                        <TextField
                            multiline
                            rows={ 8 }
                            label="Get Program Enrollment By Customer Identifier Request"
                            variant="filled"
                            value={ this.state.jsonInput }
                            onChange={ this.setRequest }
                            style={{ width: 800 }}
                        />
                    </Grid>
                }

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Submit
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Status</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    private toggleJsonInput() {
        this.setState({ isJsonInput: !this.state.isJsonInput });
    }

    private handleValidation(request : IGetProgramEnrollmentByCidRequest) {
        let formIsValid = true;
        if (!request.profileId) {
            alert('Please enter the profile id');
            formIsValid = false
        } else if (!request.profileId.match(AMAZON_ID)) {
            alert('Please enter the valid profile id.');
            formIsValid = false
        }
        if (!request.programName) {
            alert('Please enter the programName');
            formIsValid = false
        }
        return formIsValid;
    }
    private setRequestFields(field: InputField, event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: IGetProgramEnrollmentByCidRequest = this.state.request;

        switch (field) {
            case InputField.PROGRAM_NAME: {
                updatedRequest.programName = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PROFILE_ID: {
                updatedRequest.profileId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            default: {
                break;
            }
        }
    }

    private setRequest(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ jsonInput: event.target.value });
    }

    private handleSubmit() {
        this.setState({ isLoading: true });
        this.setState({ errorMessage: '' });
        let body: IGetProgramEnrollmentByCidRequest;

        if (this.state.isJsonInput) {
            body = JSON.parse(this.state.jsonInput);
            this.isValidation = this.handleValidation(body);
        } else {
            body = this.state.request;
            this.isValidation = this.handleValidation(body);
        }

        if (this.isValidation) {
            const config = {
                body,
                headers: {}
            }
            this.callGetProgramEnrollmentByCid(config);
        }
        this.setState({ isLoading: false });
    }

    private callGetProgramEnrollmentByCid(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/pharmacy-customer/get-program-enrollment-by-cid';

        console.log(config)
        API.post(apiName, path, config).then((getEnrollmentResponse: any) => {
            console.log(getEnrollmentResponse);
            this.setState({ response: getEnrollmentResponse });
            this.setState({ errorMessage: ''});
        }).catch((error) => {
            console.log(error);
            this.setState({ response: ''})
            this.setState({ errorMessage: error.response.data.message });
        });
    }
}

export default GetProgramEnrollmentByCidSection;
